interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmDialog({ open, title, message, confirmLabel = "Confirm", cancelLabel = "Cancel", danger = false, onConfirm, onCancel }: ConfirmDialogProps) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onCancel} />
      <div className="relative bg-dark-panel border border-dark-border rounded-2xl p-6 max-w-sm w-full animate-slide-up">
        <div className={`w-12 h-12 flex items-center justify-center rounded-full mx-auto mb-4 ${danger ? "bg-cyber-red/10 border border-cyber-red/30" : "bg-electric-blue/10 border border-electric-blue/30"}`}>
          <i className={`${danger ? "ri-error-warning-line text-cyber-red" : "ri-question-line text-electric-blue"} text-xl`} />
        </div>
        <h3 className="text-white font-bold text-lg text-center mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{title}</h3>
        <p className="text-silver text-sm text-center leading-relaxed mb-6">{message}</p>
        <div className="flex gap-3">
          <button onClick={onCancel} className="flex-1 py-2.5 rounded-xl border border-dark-border text-silver hover:text-white hover:border-electric-blue/40 transition-all text-sm font-medium cursor-pointer whitespace-nowrap">
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className={`flex-1 py-2.5 rounded-xl font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${danger ? "bg-cyber-red text-white hover:bg-cyber-red/80" : "bg-electric-blue text-deep-black hover:shadow-glow-blue"}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
